import { useId as useId$1 } from 'react-aria';

function useId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(prefix).concat(useId$1());
}

export { useId as default };
